var _rect, _rect2, _rect3, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEldComplaince(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.51973,
    y: 0.538285,
    width: 73.9356,
    height: 73.9356,
    rx: 36.9678,
    fill: "#020407",
    fillOpacity: 0.04
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.51973,
    y: 0.538285,
    width: 73.9356,
    height: 73.9356,
    rx: 36.9678,
    stroke: "url(#paint0_linear_706_70369)",
    strokeWidth: 1.07657
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1.51973,
    y: 0.538285,
    width: 73.9356,
    height: 73.9356,
    rx: 36.9678,
    stroke: "url(#paint1_linear_706_70369)",
    strokeWidth: 1.07657
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_706_70369)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.7256 27.6124C48.6734 28.2964 49.801 30.0201 51.2147 32.3926H45.7256V27.6124ZM28.4984 32.5918C29.0755 32.5918 29.4944 32.8704 29.4944 33.5215C29.4944 34.0706 29.0501 34.516 28.5012 34.5176H22.4834C21.9332 34.5176 21.4873 34.9637 21.4873 35.5137C21.4873 36.0639 21.9332 36.5098 22.4834 36.5098H31.4482C32.0036 36.5098 32.4482 36.9554 32.4482 37.5059C32.4482 38.056 32.0023 38.502 31.4521 38.502H22.4834C21.9332 38.502 21.4873 38.9479 21.4873 39.498C21.4873 40.0482 21.9332 40.4941 22.4834 40.4941H24.6748V43.4824C24.6748 44.0326 25.1207 44.4785 25.6709 44.4785H27.6732C28.0301 46.2367 29.5837 47.5332 31.415 47.5332C33.2464 47.5332 34.7999 46.2367 35.1569 44.4785H45.2709C45.6278 46.2367 47.1813 47.5332 49.0127 47.5332C50.8441 47.5332 52.3976 46.2367 52.7545 44.4785H54.4912C55.0414 44.4785 55.4873 44.0326 55.4873 43.4824V37.5059C55.4873 34.5832 52.4046 34.3892 52.4017 34.3848H44.7295C44.1793 34.3848 43.7334 33.9389 43.7334 33.3887V27.4121H25.6709C25.1207 27.4121 24.6748 27.858 24.6748 28.4082V30.5996H23.4795C22.9293 30.5996 22.4834 31.0455 22.4834 31.5957C22.4834 32.1459 22.9293 32.5918 23.4795 32.5918H28.4984ZM50.304 42.4236C51.0171 43.1366 51.0171 44.2933 50.304 45.0064C49.1569 46.1535 47.1865 45.3374 47.1865 43.7148C47.1865 42.0926 49.1569 41.2765 50.304 42.4236ZM32.7063 42.4236C33.4194 43.1366 33.4194 44.2933 32.7063 45.0064C31.5593 46.1535 29.5889 45.3374 29.5889 43.7148C29.5889 42.0926 31.5593 41.2765 32.7063 42.4236Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_706_70369",
    x1: -7.18521,
    y1: 4.23456,
    x2: 75.6912,
    y2: 75.0122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#024751",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.323723,
    stopColor: "#024751",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_706_70369",
    x1: 90.8146,
    y1: 91.9504,
    x2: 3.70366,
    y2: 30.2469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#024751"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.544,
    stopColor: "#024751",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_706_70369"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white",
    transform: "translate(21.4873 20.5059)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEldComplaince);
export default __webpack_public_path__ + "static/media/EldComplaince.899ecfc61cbbd50b1e3d7cb3da4012db.svg";
export { ForwardRef as ReactComponent };